module.exports = __webpack_public_path__ + "static/media/plant-happy.03690268.png";